module.exports = __webpack_public_path__ + "img/Image_01.300a3cd4.jpg";